import { Chip, ChipRow } from "../lib/Chip.tsx";
import type { StatusFilterKey } from "./collection.constants.ts";
import type { StatusFilter } from "./collection.model.ts";

/**
 * The status chips.
 *
 * Renders only when there is something to choose between: `filters` is empty
 * while the registry can answer only one of them, and a control with one option
 * is chrome pretending to be a control.
 *
 * Which collection is showing is NOT here. It is the screen's heading — the
 * same `CollectionHead` the dashboard panel uses — because the collection on
 * screen is what the grid is OF, where a status chip only narrows it. An
 * earlier version put both in this row, as a labelled "COLLECTION" dropdown
 * pushed to the right, and the same choice then looked like two different kinds
 * of control on two screens.
 */
export function CollectionToolbar({
  filters,
  activeFilter,
  onFilter,
}: {
  filters: StatusFilter[];
  activeFilter: StatusFilterKey;
  onFilter: (key: StatusFilterKey) => void;
}) {
  if (filters.length === 0) return null;

  return (
    <div className="collection__toolbar">
      <ChipRow label="Status">
        {filters.map((filter) => (
          <Chip
            key={filter.key}
            pressed={filter.key === activeFilter}
            onClick={() => onFilter(filter.key)}
          >
            {filter.label}
          </Chip>
        ))}
      </ChipRow>
    </div>
  );
}
